export function formatCurrency(value) {
  if (value === undefined || value === null) return "$0";
  return `$${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatNumber(value) {
  if (value === undefined || value === null) return "0";
  return Number(value).toLocaleString("en-US");
}

export function formatPercent(value) {
  if (value === undefined || value === null) return "0%";
  return `${Number(value).toFixed(2)}%`;
}

export function formatRoas(value) {
  if (value === undefined || value === null) return "0x";
  return `${Number(value).toFixed(2)}x`;
}

export function formatRelativeTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const diffMs = Date.now() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return "just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay}d ago`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
